




<template>
<div>











<div v-for="(item,i) in tasks.tasksList" style="margin:5px">
  <v-toolbar   color="#EDEEF0" flat>
    <v-toolbar-side-icon>
      <v-tooltip v-if="item.status.status =='stop'" bottom   open-delay="1000" max-width="200"   >
     <v-icon large slot="activator"     @click="activate(item,'run'); item.status='run'" >mdi-replay</v-icon>
     <span>{{item.status.description.text}}</span>
    </v-tooltip>


        <v-tooltip v-if="item.status.status=='run'" bottom   open-delay="1000" max-width="200"   >
     <v-icon large slot="activator" color="green"     @click="activate(item,'stop'); item.status='stop'" >mdi-stop-circle-outline</v-icon>
     <span>{{item.status.description.text}}</span>
    </v-tooltip>


     <v-tooltip v-if="item.status.status=='error'" bottom   open-delay="1000" max-width="200"   >
     <v-icon large slot="activator" color="red"     @click="activate(item,'run'); item.status='stop'" >mdi-alert-circle</v-icon>
     <span>{{item.status.description.text}}</span>
    </v-tooltip>

      </v-toolbar-side-icon>






    <v-toolbar-title  > <a @click="taskResources(item)" >   {{item.name}}  </a>  </v-toolbar-title>

    <v-spacer></v-spacer>


    <v-btn icon @click="taskActions(item)">
    <v-tooltip top max-width="250">  <v-icon slot="activator"   >mdi-worker</v-icon> <span>Действия</span>  </v-tooltip>
    </v-btn>



    <v-btn icon @click="taskAccounts(item)">
    <v-tooltip top max-width="250">  <v-icon slot="activator"   >mdi-account-multiple</v-icon> <span>Аккаунты</span>  </v-tooltip>
    </v-btn>

<v-btn icon @click="taskParams(item)">
<v-tooltip top max-width="250">  <v-icon slot="activator"   >mdi-tune</v-icon> <span>Изменить параметры задания</span>  </v-tooltip>
</v-btn>

    <v-btn icon>
    <v-tooltip top max-width="250">  <v-icon slot="activator" @click="del(item)" >mdi-close</v-icon> <span> Удалить задание</span>  </v-tooltip>
    </v-btn>


  </v-toolbar>
</div>




</div>
</template>

<script>

import axios from 'axios'

export default {

props:['tasks' ],
  data () {
    return {



    }
  },
methods:{
 activate:function(item, status){
   //console.log(item)
   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/activator.php', {
        method: 'POST',
        data: {
          id: item.task_id,
          status:status
        }
      })
      .then( response => {
          console.log(response.data)
          item.status = JSON.parse(response.data.status)
        if(response.data.status){
            axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/content_actions.php', {
              method: 'POST', data:{id:response.data.task_id }
            })
            .then( response=>{
this.tasksData()
            })
        }
      })
 },


  taskParams: function(item){

    this.tasks.task.info = item
    this.tasks.modals.params = true
    this.tasks.task.name = item.name
    this.tasks.task.params = JSON.parse(item.params)

   console.log(this.tasks.task);
  },

  taskActions: function(item){

    this.tasks.task.info = item
    this.tasks.modals.actions = true
    this.tasks.task.name = item.name
    this.tasks.task.actions = JSON.parse(item.actions)
   console.log(this.tasks.task);
  },
  taskResources: function(item){
        this.tasks.modals.resources = true

        this.tasks.task.info = item


        this.tasks.task.name = item.name


        this.tasks.task.resources.foundData.selector = false
        this.tasks.task.resources.foundData.foundIds = []
        this.tasks.task.resources.foundData.displayIds = []
        this.tasks.task.resources.foundData.selectedIds = []
        this.tasks.task.resources.foundData.offset = 0
        this.tasks.task.resources.foundData.selectAll = false

        this.tasks.task.resources.foundDataDone.selector = false
        this.tasks.task.resources.foundDataDone.foundIds = []
        this.tasks.task.resources.foundDataDone.displayIds = []
        this.tasks.task.resources.foundDataDone.selectedIds = []
        this.tasks.task.resources.foundDataDone.offset = 0
        this.tasks.task.resources.foundDataDone.selectAll = false

        axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/select_resources.php', {
             method: 'POST',
             data: {
               taskId: item.task_id
             }
           })
           .then( response => {

            if(response.data.resurces !== '') { this.tasks.task.resources.foundData.foundIds = response.data.resurces.split(',') }
            if(response.data.before_done !== '') { this.tasks.task.resources.foundDataDone.foundIds = response.data.before_done.split(',') }

           })



  },
  taskAccounts(item){
    this.tasks.task.info = item
    this.tasks.modals.accounts = true
    this.tasks.task.accountsSelected = JSON.parse(this.tasks.task.info.act_accounts)

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
         method: 'GET',
         params: {grId:item.act_acc_gr},
       })
       .then( response => {
         this.tasks.task.accounts = response.data

       })


  },

  del : function(item){
    this.tasks.deleteTask.modal = true
    this.tasks.deleteTask.taskId = item

  },

  taskData: function(id){

    this.tasks.task.selectedTaskId = id
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/get_by_id.php', {
         method: 'POST',
         data: {
           id: this.tasks.task.selectedTaskId
         }
       })
       .then( response => {
         console.log(response.data)
         this.tasks.task.accounts = JSON.parse(response.data.act_accounts)
         this.tasks.task.resources =  response.data.resurces.split(',')
         this.tasks.task.actions = JSON.parse(response.data.actions)
         this.tasks.task.name =  response.data.name
         this.tasks.task.params =  JSON.parse(response.data.params)

         console.log(this.tasks.task)
       })
  },




},
beforeDestroy() {
clearTimeout(this.tasks.task.timeoutUpdate);
}

}
</script>

<style   >

</style>
